__turbopack_context__.v({
  "select": "select-module-scss-module__41NGPW__select",
  "selectContent": "select-module-scss-module__41NGPW__selectContent",
  "selectIcon": "select-module-scss-module__41NGPW__selectIcon",
  "selectItem": "select-module-scss-module__41NGPW__selectItem",
  "selectItemIndicator": "select-module-scss-module__41NGPW__selectItemIndicator",
  "selectTrigger": "select-module-scss-module__41NGPW__selectTrigger",
  "selected": "select-module-scss-module__41NGPW__selected",
});
